import React from "react";

import { cn } from "@/src/lib/utils";

import { PAYMENT_ICONS } from "./paymentIcons";
import { CELL_ICON_CLASS } from "../../../dataTable/dataTableStyles";

import type { JSX } from "react";

import type { PaymentKind } from "./paymentIcons.types";

interface PaymentIconComponentProps {
  kind: PaymentKind;
}

function PaymentIcon({ kind }: PaymentIconComponentProps): JSX.Element {
  const Icon = PAYMENT_ICONS[kind];
  return (
    <Icon
      aria-hidden="true"
      className={cn(CELL_ICON_CLASS, kind !== "retailer" && "fill-current")}
    />
  );
}

export default PaymentIcon;
